/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { useEffect, useRef } from 'react';

export default function useWindowUnloadEffect(handler, callOnCleanup) {
  const cb = useRef();
  cb.current = handler;

  useEffect(() => {
    const handlerCaller = () => cb.current();
    window.addEventListener('beforeunload', handlerCaller);

    return () => {
      if (callOnCleanup) handlerCaller();
      window.removeEventListener('beforeunload', handlerCaller);
    };
  }, [callOnCleanup]);
}
